<template>
  <div class="guideline-page">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Important Guidelines</div>
      </q-card-section>
      <q-separator />

      <q-card-section class="card-content">
        <GuidelineSlot
          v-for="guide in getGuides"
          :key="guide.ID"
          :guide="guide"
        />
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import GuidelineSlot from './GuidelinesSlot.vue'
import { mapGetters } from 'vuex';
export default {
  name: 'GuidelinesPage',
  components: {
    GuidelineSlot
  },
  computed: {
    ...mapGetters({
      getGuides: 'home/getGuides'
    })
  }
}
</script>

<style lang="scss">
.guideline-page {

  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
    }
  }
}
</style>